import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoging: false,
  isLogedIn: false,
  user: {},
  users: [],
};
const UserOauthSlice = createSlice({
  name: 'AdminOauthSlice',
  initialState,
  reducers: {
    userLoginRequest: (state, action) => {
      state.isLoging = true;
    },
    userLoginSuccess: (state, action) => {
      state.isLogedIn = true;
      state.isLoging = false;
      state.user = { ...action.payload };
    },
    userLoginFailed: (state, action) => {
      state.isLoging = false;
      state.isLogedIn = false;
      state.user = {};
    },
    logout: (state, action) => {
      state.isLogedIn = false;
      state.user = {};
    },
  },
});
export default UserOauthSlice.reducer;
export const { userLoginRequest, userLoginSuccess, userLoginFailed, logout } =
  UserOauthSlice.actions;
